import type { U2000FormStateHandlers } from "../../../reducer/formReducer/U2000FormStateHandlers";
import { FaExclamationTriangle } from "react-icons/fa";

interface U2000InvalidFeedbackProps<T extends Record<string, any>> {
  formStateHandlers: U2000FormStateHandlers<T>;
  fieldName: string;
}

const U2000InvalidFeedback = <T extends Record<string, any>>({ formStateHandlers, fieldName }: U2000InvalidFeedbackProps<T>) => {
  const errors = formStateHandlers.getErrors();
  const errorMessage = errors[fieldName];
  if (errorMessage === undefined || errorMessage === null || String(errorMessage).trim() === "") return null;

  // Aligné sur le cadre rouge des inputs : pas de flash d'erreur sur les champs non touchés
  // (ex. validation globale au blur d'une date qui marquait tous les libellés vides).
  const touched = formStateHandlers.getTouched()?.[fieldName];
  const show = Boolean(touched) || formStateHandlers.isSubmitted();
  if (!show) return null;

  return (
    <div className="flex items-start gap-1.5 mt-1.5 animate-fade-in">
      <FaExclamationTriangle className="w-3.5 h-3.5 text-red-500 shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-sm text-red-600 leading-tight" role="alert" aria-live="polite">
        {errorMessage}
      </p>
    </div>
  );
};

export default U2000InvalidFeedback;
